/**
 * Phase 0 «Замкнути коробки» (#108): secure resolution of the Matrix client mode.
 *
 * Kept in its own dependency-free module so it can be unit-tested in isolation (importing
 * the full matrixClient pulls in axios, which the CRA/jest transform does not handle).
 *
 * - Default is `backend` — proxy through the Java backend, which enforces club-scoped authz.
 * - `direct` mode talks straight to Synapse with an admin token and is DEV-ONLY: it is
 *   honoured only outside a production build, so a leaked or misconfigured
 *   `REACT_APP_MATRIX_MODE=direct` can never ship the admin-token path to production.
 *   (Previously the default was `direct`.)
 */
export function resolveMatrixMode(
  mode: string | undefined = process.env.REACT_APP_MATRIX_MODE,
  nodeEnv: string | undefined = process.env.NODE_ENV,
): "direct" | "backend" {
  if (mode === "direct" && nodeEnv !== "production") {
    return "direct";
  }
  if (mode === "direct" && nodeEnv === "production") {
    // eslint-disable-next-line no-console
    console.warn("[Matrix] Direct mode requested but IGNORED in a production build — using backend proxy");
  }
  return "backend";
}
